<template>
  <div class="order">
    <div class="header-tool">
      <div class="header-tool-info">
         <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index">订单中心</BreadcrumbItem>
          <BreadcrumbItem to="/exhibition/index/order/all-order">全部订单</BreadcrumbItem>
          <BreadcrumbItem>订单详情</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">订单详情</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/index/order/all-order')">
          <i class="icon iconfont icon-LOGO-" style="font-size:20px;"></i>
          <span>返回</span>
        </div>
      </div>
    </div>

    <div class="detail-content">
      <div class="detail-num">订单号：2131384684153</div>
      <div class="detail-info">
        <span style="display:inline-block;margin:0 100px 20px 0;">购买用户：第三季福克斯</span>
        <span>手机号：138168113512531</span>
        <br/>
        <span>地址信息：上海市</span>
      </div>
      <div style="padding:30px;">
        <template v-if="list && list.length" >
          <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false">
            <template slot-scope="{ row, index }" slot="name">{{row.name}}</template>
            <template slot-scope="{ row, index }" slot="pic">
              <div style="position:relative">
                <div class="goods" v-for="(item,index) of row.pic" :key="index">
                  <img :src="item">
                </div>
                <div class="goods-e" v-show="row.pic.length === 5">...</div>
              </div>
            </template>
            <template slot-scope="{ row, index }" slot="price">{{row.price}}元</template>
            <template slot-scope="{ row, index }" slot="num">{{row.num}}件</template>
            <template slot-scope="{ row, index }" slot="total">{{row.price * row.num}}元</template>
            <div slot="footer" style="padding:0 50px;display:flex;justify-content:space-between">
              <p>合计：<span style="color:#de0808;">109803元</span></p>
              <span style="color:#1890ff;">已付款</span>
            </div>
          </Table>
          <Button type="primary" @click="sendFlag1 = true" style="margin:20px 0 0 0;">确认发货</Button>
          <Button type="primary" @click="sendFlag2 = true" v-if="true" style="margin:20px 0 0 0;">查看物流</Button>
        </template>
      </div>
    </div>

    <!-- 确认发货 -->
    <iModal
      v-model="sendFlag1"
      title="物流信息"
      :styles="{top:'350px'}"
      width="400"
      @on-ok="send"
      @on-cancel="cancel">
      <Form style="padding:10px 40px 0">
        <FormItem label="快递公司：">
          <Select v-model="express" style="width:200px;">
            <Option v-for="item in expressList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="物流单号：">
          <Input type="text" style="width:200px;" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary">确定</Button>
        <Button style="margin-left:10px;">取消</Button>
      </div>
    </iModal>

    <!-- 查看物流 -->
    <iModal
      v-model="sendFlag2"
      title="物流信息"
      :styles="{top:'200px'}"
      width="500"
      @on-ok="send"
      @on-cancel="cancel">
        <div class="express-header">
          <p>物流单号：6865351515161</p>
          <p>快递公司：申通快递</p>
        </div>
        <div class="express-content">
          <div style="display:flex;margin-bottom:10px;">
            <p style="margin-right:30px;">运输中</p>
            <p>
              您的订单已出库
              <br/>
              2019/10/22 13:50:50
            </p>
          </div>
          <div style="display:flex;margin-bottom:10px;">
            <p style="margin-right:30px;">运输中</p>
            <p>
              您的订单已出库
              <br/>
              2019/10/22 13:50:50
            </p>
          </div>
          <div style="display:flex;margin-bottom:10px;">
            <p style="margin-right:30px;">运输中</p>
            <p>
              您的订单已出库
              <br/>
              2019/10/22 13:50:50
            </p>
          </div>
        </div>
      <div slot="footer">
        <Button type="primary">确定</Button>
        <Button style="margin-left:10px;">取消</Button>
      </div>
    </iModal>

    <Contact />
  </div>
</template>

<script>
import Contact from "@components/Contact/Contact";

export default {
  name: "exhibition-order-detail",
  data() {
    return {
      list: [{
        name: 1245255,
        pic: ["https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg"],
        price: "56",
        num: "2",
        },{
        name: 1245255,
        pic: ["https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg"],
        price: "43434",
        num: "5",
        }],
      columns1: [
        {
          title: "产品名称",
          key: "name",
          slot: "name",
          align: "center"
        },
        {
          title: "产品图",
          slot: "pic",
          key: "pic",
          align: "center",
          width: "300"
        },
        {
          title: "单价",
          slot: "price",
          key: "price",
          align: "center"
        },
        {
          title: "数量",
          slot: "num",
          key: "num",
          align: "center"
        },
        {
          title: "小计",
          slot: "total",
          key: "total",
          align: "center"
        },
      ],
      sendFlag1: false,
      sendFlag2: false,
      expressList: [
        {
          value: '申通快递',
          label: '申通快递'
        },
        {
          value: '顺丰',
          label: '顺丰'
        },
      ],
      express: ""
    }
  },
  components: {
    Contact,
  },
  methods: {
    send() {
      
    },
    cancel() {

    }
  }
}
</script>

<style lang="scss" scoped>
.detail-content {
  min-width: 1000px;
  margin: 30px;
  min-height: 500px;
  background-color: #fff;
  .detail-num {
    width:100%;
    padding:30px;
    border-bottom:1px solid #dddddd;
  }
  .detail-info {
    width:100%;
    padding:30px;
  }
  .goods {
    width: 17%;
    padding: 10% 0;
    display: inline-block;
    position: relative;
    margin: 0 3px;
    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }
  }
  .goods-e {
    position: absolute;
    left: 100%;
    top: 20%;
    font-weight: bold;
  }
}
.express-header {
  width: 500px;
  height: 50px;
  margin-left: -16px;
  padding: 0 10% 2%;
  border-bottom: 1px solid #dddddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
}
.express-content {
  width: 500px;
  margin-left: -16px;
  padding: 2% 10%;
  color: #808080;
}
</style>
<style lang="scss">
.detail-content {
  .ivu-table-wrapper {
    border: none;
    .ivu-table:after {
      width: 0;
    }
  }
}
</style>